import { http } from 'App/http';

export default {
    state: {
        relationshipTypes: [],
        loaded: false,
        loading: false
    },

    getters: {
        all: (state) => state.relationshipTypes,
        isLoaded: (state) => state.loaded,
        isLoading: (state) => state.loading,
    },

    mutations: {
        setRelationshipTypes: (state, value) => state.relationshipTypes = value,
        setLoaded: (state, value) => state.loaded = value,
        setLoading: (state, value) => state.loading = value,
    },

    actions: {
        loadRelationshipTypes ({ commit, state }) {
            if (state.loaded || state.loading) {
                return;
            }

            http.get('/app/relationship-types')
                .then(response => {
                    commit('setRelationshipTypes', response.data)
                })
                .finally(() => {
                    commit('setLoaded', true);
                    commit('setLoading', false);
                })
        },
    }
}